import i18n from 'i18next';
import en from './en.json';
import es from './es.json';
import pt from './pt.json';

export const NS = 'inbox-agent-calls';

// Guard the registration so importing this module is safe where the i18next
// singleton isn't initialized (the jest runner). In the app, i18n is initialized
// before features load, so this always runs. Imported eagerly by the route
// skeleton too (SL-1908), so its accessible name is translated on a cold load.
if (typeof i18n.addResourceBundle === 'function') {
  i18n.addResourceBundle('en', NS, en, true, true);
  i18n.addResourceBundle('es', NS, es, true, true);
  i18n.addResourceBundle('pt', NS, pt, true, true);
}

export { en, es, pt };
